import { render } from "./VenueDetail.vue?vue&type=template&id=ae691a66&scoped=true"
import script from "./VenueDetail.vue?vue&type=script&lang=js"
export * from "./VenueDetail.vue?vue&type=script&lang=js"

import "./VenueDetail.vue?vue&type=style&index=0&id=ae691a66&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ae691a66"

export default script